<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isShowLeftSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-show-left-sidebar', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Thông tin đơn vị</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Mã"
            rules="required"
          >
            <label label-for="Code" style="font-size: 13px"
              >Mã <span style="color: red">*</span></label
            >
            <b-form-group>
              <b-form-input
                id="Code"
                v-model="formData.code"
                :state="getValidationState(validationContext)"
                trim
                :disabled="isWait"
                placeholder="Mã"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Tên"
            rules="required"
          >
            <label label-for="Name" style="font-size: 13px"
              >Tên <span style="color: red">*</span></label
            >
            <b-form-group>
              <b-form-input
                id="Name"
                v-model="formData.name"
                :state="getValidationState(validationContext)"
                :disabled="isWait"
                placeholder="Tên"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Description"
            rules=""
          >
            <b-form-group label="Mô tả" label-for="Description">
              <b-form-input
                id="Description"
                v-model="formData.description"
                :state="getValidationState(validationContext)"
                :disabled="isWait"
                placeholder="Mô tả"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="isWait"
              type="submit"
            >
              Lưu
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="isWait"
              @click="hide"
            >
              Đóng
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, alphaNum, email, url } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import vi from "vee-validate/dist/locale/vi.json";
localize("vi", vi);
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  CapThongKeCreate as dataCreate,
  CapThongKeUpdate as dataUpdate,
} from "@/services/api/HoSoCanBoCongChuc/DanhMuc/DonViThongKeService";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    parentId: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      required: true,
    },
    isShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isWait: false,
      required,
      alphaNum,
      email,
      url,
    };
  },
  methods: {
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        if (this.formData.id && this.formData.id != "") {
          //Update
          this.isWait = true;
          var res = await dataUpdate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data");
          }
        } else {
          //Create
          this.isWait = true;
          // this.formData.idDonViCha = this.parentId ? this.parentId : null;
          var res = await dataCreate(this.formData);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            //this.formData.id = res.data.id
            this.$emit("update:is-show-left-sidebar", false);
            this.$emit("refetch-data");
          }
        }
      }
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
